import styles from "./SelectShapeType.module.scss";
import { ShapeType } from "../../common/CommonType";
import { useState } from "react";
import CSCNoWorkTime from "../CSCNoWorkTime/CSCNoWorkTime";
import { InfoType } from "@/hooks/userInfo";
import RegularModal from "../Modal/RegularModal";
import { useCSC } from "@/hooks";
import DesignerModal from "../Modal/DesignerModal";
import AbtestSaleTip from "@/components/AbtestSaleTip/AbtestSaleTip";
import { GIO, GioModuleVar } from "@/utils/gioUtils";

function SelectShapeType() {
  const [shape, setShape] = useState(ShapeType.I_SHAPE);
  const [infoType, setInfoType] = useState<InfoType>(InfoType.L_SHAPE);
  const [openCSC, setOpenCSC] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false)
  const [showErrorTel, setShowErrorTel] = useState(false)
  const { isWorkTime } = useCSC();

  function handleClick(type: ShapeType, typeDesc: string) {
    setShape(type)
    GIO('track', 'clickData', {
      eventType_var: 'click',
      module_var: GioModuleVar.shapeChoose,
      objectName_var: typeDesc,
    })
    if (type === ShapeType.L_SHAPE || type === ShapeType.U_SHAPE) {
      setInfoType(InfoType[type])
      setOpenCSC(true)
    }
  }

  const closeCSC = () => {
    setOpenCSC(false);
    setShape(ShapeType.I_SHAPE)
  }

  const tipContent = (<p>抱歉，由于转角柜设计的复杂性，建议您留下联系方式，我们的线上专属设计师会联系您并提供免费设计服务，服务时间为：<strong>9:00-22:00</strong></p>)

  return (
    <div className={styles.shapeWrap}>
      <div className={styles.Label}>
        <span>柜型</span>
      </div>
      <div className={styles.optionWrap}>
        <div className={`${styles.DoorTypeOption} ${shape === ShapeType.I_SHAPE ? styles.Active : ""}`}
          onClick={() => handleClick(ShapeType.I_SHAPE, '立柜')}>
          <div className={styles.DoorTypeIcon + " " + styles.ShapeI} />
          <span>立柜</span>
          <AbtestSaleTip text="94%顾客选择"></AbtestSaleTip>
        </div>

        <div className={`${styles.DoorTypeOption} ${shape === ShapeType.L_SHAPE ? styles.Active : ""}`}
          onClick={() => handleClick(ShapeType.L_SHAPE, 'L型柜')}>
          <div className={styles.DoorTypeIcon + " " + styles.ShapeL} />
          <span>L型柜</span>
        </div>

        <div className={`${styles.DoorTypeOption} ${shape === ShapeType.U_SHAPE ? styles.Active : ""}`}
          onClick={() => handleClick(ShapeType.U_SHAPE, 'U型柜')}>
          <div className={styles.DoorTypeIcon + " " + styles.ShapeU} />
          <span>U型柜</span>
        </div>
      </div>
      <DesignerModal
        title={'转角柜设计'}
        tip={"抱歉，由于转角柜设计的复杂性，我们的线上专属设计师会为您提供免费设计服务。"}
        cscCustomerText={`Pax设计工具：我需要设计${shape === ShapeType.L_SHAPE ? 'L' : 'U'}型转角柜。`}
        open={openCSC && isWorkTime} onClose={closeCSC}
      />
      <CSCNoWorkTime
        infoType={infoType}
        openCSC={openCSC && !isWorkTime}
        showTip={true}
        tipContent={tipContent}
        hide={closeCSC}
        showSuccessAlert={() => { setShowSuccess(true) }}
        showErrorTelAlert={() => { setShowErrorTel(true) }}
      />
      <RegularModal
        open={showSuccess}
        sureText={'我知道了'}
        noCloseIcon={true}
        sureFn={() => { setShowSuccess(false) }}
        disableBackdropClick={true}
      >
        {'我们的线上专属客服会在近期联系您，请您耐心等候。'}
      </RegularModal >
      <RegularModal
        open={showErrorTel}
        sureText={'我知道了'}
        noCloseIcon={true}
        sureFn={() => { setShowErrorTel(false) }}
        disableBackdropClick={true}
      >
        {'您输入的号码格式错误，请输入正确的 11 位数电话号码。'}
      </RegularModal >
    </div>)
}

export default SelectShapeType;
